import dayjs from 'dayjs';

import AppApi from './app-api';

class FortuneApi {
  constructor(private api: AppApi) {}

  async create(body: CreateFortuneBodyDto) {
    try {
      const res = await this.api.INSTANCE.post(`/fortune`, {
        shopName: body.shopName,
        openedAt: dayjs(body.openedAt).format('YYYY-MM-DD'),
        userId: body.userId,
        category: body.category,
      });
      return res.data;
    } catch (e) {
      throw e;
    }
  }

  // shopName: string;

  // @ApiProperty({
  //   description: '오픈일',
  //   example: '2021-01-01',
  //   format: 'date',
  // })
  // openedAt: Date;

  // @ApiPropertyOptional({
  //   description: '유저 아이디 (optional)',
  //   format: 'string',
  // })
  // userId?: string;

  async getFortune(params: GetFortuneParamsDto) {
    try {
      const res = await this.api.INSTANCE.get(
        `/fortune?shopName=${params.shopName}&openedAt=${dayjs(params.openedAt).format('YYYY-MM-DD')}`,
      );
      return res.data;
    } catch (e) {
      throw e;
    }
  }

  async update(params: PatchFortuneParamsDto) {
    try {
      const res = await this.api.INSTANCE.patch(`/fortune/${params.fortuneId}`, {
        userId: params.userId,
      });
      return res.data;
    } catch (e) {
      throw e;
    }
  }
}

export type CreateFortuneBodyDto = {
  shopName: string;
  openedAt: string; // YYYY-MM-DD
  userId?: string;
  category?: string;
};

export type GetFortuneParamsDto = {
  shopName: string;
  openedAt: string; // YYYY-MM-DD
};

export type PatchFortuneParamsDto = {
  fortuneId: string;
  userId: string;
};

export type ResponseFortuneDataDto = {
  fortuneId: string;
  shopName: string;
  openedAt: Date;
  fortunePrediction: string;
  overallFortune: string;
  financialFortune: string;
  customerFortune: string;
  optionalEfficiency: string;
  futureOfYears: string;
  lottery: number;
};

export default FortuneApi;
